import React from 'react';

import { Form, Button, Container } from 'react-bootstrap';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';


import './index.css'

function SuccessModal({ username, password}) {
  const body = document.getElementsByTagName('body')[0];

  const closeModal = () => {
    ModalManager.close();
    body.style.overflow = 'auto'
  }
  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflowX: 'hidden',
      overflowY: 'auto',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      position: 'relative',
      border: '1px solid rgba(0, 0, 0, .2)',
      width: 'inherit',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
    }
  }

  return (
    <div className="DisableUserModal">

      <Modal
        style={style}
        onRequestClose={() => { }}
        effect={Effect.Fall}>
        <Container fluid>
          <div className="header">
            <div className="title">
              Empresa cadastrada com Sucesso
          </div>
          </div>
          <div>
            <p><b>Usuário:</b> {username}</p>
            <p><b>Senha:</b> {password}</p>
          </div>
          
          <div className="body">
            <Form>
              <Form.Group>
                <Button variant="primary" className="customBtn" sm6 onClick={closeModal}>
                  `Voltar para Meus Dispositivos
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Container>
      </Modal>
    </div>
  );
}

export default SuccessModal;